<div class="image-banner-container">
  <img width="100%" [src]="bannerImageAssetPath" alt="" class="image-banner lazy-load loaded" typeof="foaf:Image"
    data-was-processed="true">
</div>

<div class="content-div">
  <span class="home-title">
    <persistent-simple-text-section-entity section="homePage.main.title">
    </persistent-simple-text-section-entity>
  </span>
  <span class="home-message">
    <persistent-rich-text-section-entity section="homePage.main.text"></persistent-rich-text-section-entity>
  </span>

  <div class="home-column">

    <div class="home-row">
      <mat-card class="home-card">
        <mat-card-header>
          <mat-card-title>
            <persistent-simple-text-section-entity section="homePage.motd.title">
            </persistent-simple-text-section-entity>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <persistent-rich-text-section-entity section="homePage.motd.text"></persistent-rich-text-section-entity>
        </mat-card-content>
      </mat-card>
      <mat-card class="home-card">
        
        <app-homepage-actions [displayedNotificationTypes]="displayedNotificationTypes"></app-homepage-actions>
        <br>
        <mat-divider></mat-divider>
        <br>
        <app-todolist></app-todolist>
        
      </mat-card>
    </div>

</div>
